
export default (requests, axios) => {
    return {
        getCmsPage: (url, countryCode, languageCode, brand) => {
            if (!countryCode && !languageCode && !brand) {
                return requests.get(`cms/pages/${url}/content`);
            } else {
                return requests.get(`cms/pages/${url}/content?wrapComponents=true&languageCode=${languageCode}&countryCode=${countryCode}&brand=${brand}`);
            }
        }
    }
};
